import { render, staticRenderFns } from "./WidgetProductReviewsProductOptionsMobile.vue?vue&type=template&id=05b293d3"
import script from "./WidgetProductReviewsProductOptionsMobile.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsProductOptionsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports